import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { Constant } from '../@shared/constants/Constant';
import { DATE_TIME_FORMATE } from '../shared/properties/date-time.properties';

@Pipe({ name: 'localDate', pure: true })
export class FormatedatePipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}

  transform(date: Date | string, format?: string): string {
    try {
      if (date != null) {
        let supportedDate: Date;
        if (date instanceof Date) {
          supportedDate = new Date(date.getTime());
        } else {
          const tempDate = date.toString();
          let safariSupportDateFormate = '';
          if (!tempDate.includes('/')) {
            safariSupportDateFormate =
              tempDate.split('-').join('/').split('T')[0].split('/')[1] +
              '/' +
              tempDate.split('-').join('/').split('T')[0].split('/')[2] +
              '/' +
              tempDate.split('-').join('/').split('T')[0].split('/')[0] +
              ' ' +
              tempDate.split('-').join('/').split('T')[1];
          } else {
            safariSupportDateFormate = tempDate;
          }
          supportedDate = new Date(safariSupportDateFormate);
        }
        supportedDate.setMinutes(supportedDate.getMinutes() + Number(Constant.selectedOffsetTime));
        const convertedDate = new Date(supportedDate);
        const abc = this.datePipe.transform(convertedDate, DATE_TIME_FORMATE);
        return abc + ' (' + Constant.selectedTimeZoneShortValue.split('(')[0] + ')';
      } else {
        return '';
      }
    } catch (error) {
      return '';
    }
  }
}
